import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-monitoreo-alarmas',
  templateUrl: './monitoreo-alarmas.component.html',
  styleUrls: ['./monitoreo-alarmas.component.scss']
})
export class MonitoreoAlarmasComponent {

  @Input() loading1: boolean = false;
  @Input() loading3: boolean = false;
  @Input() datareporte1: any[] = [];
  @Input() datareporte3: any[] = [];
  @Input() selectedRow: any = null;

  @Output() refreshAlarmas = new EventEmitter<void>();
  @Output() rowClicked = new EventEmitter<any>();

  cols1 = ['provincia', 'tecnico', 'criticas', 'cantalarmas'];
  cols3 = ['provincia', 'tipo', 'descripcion', 'orden', 'tecnico', 'fechahora'];

  onRefresh() {
    this.refreshAlarmas.emit();
  }

  onRowClick(row: any) {
    this.rowClicked.emit(row);
  }
}
